import styled from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'

export const StyledComboboxInput = styled(Tonality.ComboboxInput).attrs(
  ({ theme, hasError }) => ({
    inputLabelStyles: {
      background: theme.colors.neutralW20,
      color: hasError ? theme.colors.error70 : theme.colors.neutralW100
    },
    style: {
      background: theme.colors.neutralW20,
      color: theme.colors.neutralW100,
      borderColor: hasError ? theme.colors.error70 : theme.colors.neutralW50
    }
  })
)``

export const StyledComboboxSearchInput = styled(
  Tonality.ComboboxSearchInput
).attrs(({ theme, hasError }) => ({
  inputLabelStyles: {
    background: theme.colors.neutralW20,
    color: hasError ? theme.colors.error70 : theme.colors.neutralW100
  },
  style: {
    borderColor: hasError ? theme.colors.error70 : theme.colors.neutralW50
  }
}))``
